import { IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/react';

export const WebHeader: React.FC<{ title: string }> = ({ title }) => {
    return (
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="start">
                    <IonMenuButton />
                </IonButtons>
                <div className="header-d flex">
                    <IonTitle>{title}</IonTitle>
                    <IonTitle className="madper-title flex-grow-0">MadPER Pointage</IonTitle>
                </div>
            </IonToolbar>
        </IonHeader>
    );
};
